import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app/App";
import "./styles/global.css";
import { startPerformanceCapture } from "./lib/performanceDiagnostics";

if (new URLSearchParams(window.location.search).get("perf") === "1") startPerformanceCapture();

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Elemento #root nao encontrado no index.html");
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
